import { render, staticRenderFns } from "./ReviewStep.vue?vue&type=template&id=baedea48&scoped=true"
import script from "./ReviewStep.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReviewStep.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ReviewStep.vue?vue&type=style&index=0&id=baedea48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baedea48",
  null
  
)

export default component.exports